import { render } from "./ReportarIncidenciaStreamlined.vue?vue&type=template&id=1588b3b5&scoped=true"
import script from "./ReportarIncidenciaStreamlined.vue?vue&type=script&lang=ts"
export * from "./ReportarIncidenciaStreamlined.vue?vue&type=script&lang=ts"

import "./ReportarIncidenciaStreamlined.vue?vue&type=style&index=0&id=1588b3b5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1588b3b5"

export default script